import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';

@Injectable({
    providedIn:'root'
})
 export class UpplmServices{
    baseUrl = 'http://localhost:5000/api/';
    public viewchangeValue: string;
    public TransactionID: string | null;

    constructor(private _http:HttpClient){
    }
    viewChanged = new Subject();
    getPlacards():Observable<any>{
        let url = this.baseUrl + 'Customers/1/Locations/1/Placards';
        return this._http.get<any>(url);
    }

 }